import React from 'react';
import { IS_PRO } from './product';

// TagAlong "Pin-O" wordmark (logo concept 3): the "o" in "along" is a map pin.
// color = the letters' color (navy on light, white on dark). Pin stays orange.
// pro = show the red "PRO" badge tucked at the top-right (defaults on for the
// TagAlong Pro build so the company portal is branded everywhere the logo shows).
export function TagAlongWordmark({ size = 22, color = '#12324a', pin = '#f8703c', pro = IS_PRO }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'flex-start', fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: `${size}px`, color, letterSpacing: '0.3px', lineHeight: 1 }}>
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        TagAl
        <span style={{ display: 'inline-flex', alignItems: 'flex-end', margin: '0 2.5px' }}>
          <TagAlongPin size={size * 1.12} pin={pin} dot={color} />
        </span>
        ng
      </span>
      {pro && (
        <sup style={{
          fontSize: `${Math.round(size * 0.4)}px`,
          fontWeight: 900,
          color: '#e11d2e',
          letterSpacing: '1.5px',
          lineHeight: 1,
          marginLeft: `${Math.max(2, size * 0.1)}px`,
          marginTop: `${size * 0.02}px`,
          top: 0,
          textShadow: '0 1px 1px rgba(0,0,0,0.18)',
        }}>PRO</sup>
      )}
    </span>
  );
}

// the pin mark on its own (app icon / small avatar)
export function TagAlongPin({ size = 26, pin = '#f8703c', dot = '#12324a' }) {
  return (
    <svg width={size * 0.74} height={size} viewBox="0 0 24 30" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      <path d="M12 0.8C5.9 0.8 1.4 5.3 1.4 11.2C1.4 18.7 12 29.2 12 29.2C12 29.2 22.6 18.7 22.6 11.2C22.6 5.3 18.1 0.8 12 0.8Z" fill={pin} />
      <circle cx="12" cy="11.2" r="4.1" fill={dot} />
    </svg>
  );
}

export default TagAlongWordmark;
